const useCategoryPieData = ({ categories, selectedCategory }) => {
  const categoriesPieData = categories.map(category => ({
    value: category.fte_p,
    round_fte_p: category.round_fte_p,
    fte: category.fte,
    benchmark: category.benchmark,
    name: category.name,
    color: category.color
  }));
  const activeIdx = categories.findIndex(
    category => category.name === selectedCategory?.name
  );

  return { categoriesPieData, activeIdx };
};

export default useCategoryPieData;
